export default __webpack_public_path__ + "static/media/home_sec_2.7475b69f.svg";